module.exports = __webpack_public_path__ + "static/img/baobian.a094aa8a.png";